import React from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Login from './Views/Login/Login';
import Home from './Views/Home/Home';
import Navbar from './Components/Navbar/Navbar'; 
import AddUser from './Views/AddUser/AddUser'; 
import ListUser from './Views/ListUser/ListUser';
import AddTrainer from './Views/AddTrainer/AddTrainer';
import ListTrainer from './Views/ListTrainer/ListTrainer';
import IngresoPorDNI from './Views/IngresoPorDNI/IngresoPorDNI';
import DniLoginModal from './Views/DniLoginModal/DniLoginModal';
import EditUser from './Views/EditUser/EditUser';
import Statistics from './Views/Statistics/Statistics';

import './App.css';

function PrivateRoute({ children }) {
  const gym = useSelector(state => state.gym);
  return gym ? children : <Navigate to="/" />;
}

function App() {
  const gym = useSelector(state => state.gym);
  const location = useLocation();

  // Oculta la navbar solo en la ruta de login
const hideNavbar = location.pathname === '/' || location.pathname === '/dni-login-modal';

  return (
    <div className="App">
      {!hideNavbar && gym && <Navbar />}
      <Routes>
        <Route path="/" element={<Login />} />
        <Route
          path="/home"
          element={
            <PrivateRoute>
              <Home />
            </PrivateRoute>
          }
        />
          <Route
          path="/add-user"
          element={
            <PrivateRoute>
              <AddUser />
            </PrivateRoute>
          }
        />
           <Route
          path="/edit-user/:id"
          element={
            <PrivateRoute>
              <EditUser />
            </PrivateRoute>
          }
        />
            <Route
          path="/users"
          element={
            <PrivateRoute>
              <ListUser />
            </PrivateRoute>
          }
        />
                <Route
          path="/add-trainer"
          element={
            <PrivateRoute>
              <AddTrainer />
            </PrivateRoute>
          }
        />
        <Route
          path="/trainers"
          element={
            <PrivateRoute>
              <ListTrainer />
            </PrivateRoute>
          }
        />

          <Route
          path="/balances"
          element={
            <PrivateRoute>
              <Statistics  />
            </PrivateRoute>
          }
        />

        <Route path="/dni-login" element={<IngresoPorDNI />} />
<Route path="/dni-login-modal" element={<DniLoginModal />} />
        {/* Agrega aquí más rutas protegidas si lo necesitas */}
      </Routes>
    </div>
  );
}

export default App;
